export default __webpack_public_path__ + "static/media/info.eb8bc58a.pdf";